<template>
  <div v-cloak class="animated fadeIn">
    <h1 class="mb-4">Output Files</h1>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-header bg-transparent">
            <div class="col-lg-12">
              <div class="justify-content-between align-items-center">
                Data files
              </div>
              <hr />
            </div>
          </div>
          <div class="card-body" v-if="tableData.length">
            <table-component
              :columns="columns"
              :data="tableData"
              :filter-exclude-columns="columns"
              :default-order-by="'-process_date'"
            >
              <template slot="filename" slot-scope="{ row }">
                <span
                  class="link pointer"
                  @click="
                    $downloadFile({
                      name: row.filename,
                      fileId: 3,
                      url: `${BASE_URL}api/files/download/`,
                    })
                  "
                >
                  {{ row.filename }}
                </span>
              </template>
            </table-component>
          </div>
          <div class="card-body" v-else>
            <a> Please Add a Data File </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BASE_URL } from "@/constants/config";

export default {
  name: "CriProcess",
  data() {
    return {
      BASE_URL,
      columns: [
        "process_date",
        "extraction_date",
        "number_of_tenders",
        "matched_counterparts",
        "filename",
      ],
      tableData: [],
    };
  },
  async mounted() {
    this.tableData = (
      await this.$request({
        url: `${BASE_URL}api/overview/cri_process`,
      })
    ).data;
  },
};
</script>

<style scoped></style>
